module.exports = __webpack_public_path__ + "static/media/_MIC2504.thumbnail.5da56304.png";